const v1 = `/api/v1`;

const authBasePrefix = `${v1}/Auth/`;
export const auth = {
  login: () => `${authBasePrefix}login`,
  verifyCode: () => `${authBasePrefix}verifyCode`,
  refresh: () => `${authBasePrefix}refresh`,
  register: () => `${authBasePrefix}register`,
  recoverPassword: () => `${authBasePrefix}recoverPassword`,
};

const cardsBasePrefix = `${v1}/Cards/`;
export const cards = {
  cardsAll: () => `${cardsBasePrefix}all/`,
  cardsProducts: () => `${cardsBasePrefix}products`,
  cardsLatest: () => `${cardsBasePrefix}latest`,
  invoices: (id: string) => `${cardsBasePrefix}invoices/${id}`,
  invoicesDownload: (id: string) => `${cardsBasePrefix}invoices/download/${id}`,
  invoicesPrint: (id: string) => `${cardsBasePrefix}invoices/print/${id}`,
  statements: (id: string) => `${cardsBasePrefix}statements/${id}`,
  statementsDownload: (id: string) => `${cardsBasePrefix}statements/download/${id}`,
  statementsPrint: (id: string) => `${cardsBasePrefix}statements/print/${id}`,
  apply: () => `${cardsBasePrefix}apply`,
  changeName: (id: string) => `${cardsBasePrefix}manage/name/${id}`,
  viewPin: (id: string) => `${cardsBasePrefix}manage/viewPin/${id}`,
  changePin: (id: string) => `${cardsBasePrefix}manage/changePin/${id}`,
  lost: (id: string) => `${cardsBasePrefix}manage/lost/${id}`,
  block: (id: string) => `${cardsBasePrefix}manage/block/${id}`,
  allInvoices: (cardId: string) => `${cardsBasePrefix}allinvoices/${cardId}`,
  allStatements: (cardId: string) => `${cardsBasePrefix}allstatements/${cardId}`,
  postDisputeTransactions: () => `${cardsBasePrefix}dispute/transactions`,
  get3ds: (id: string) => `${cardsBasePrefix}3ds/${id}`,
  set3ds: (id: string) => `${cardsBasePrefix}3ds/${id}`,
  invoicesView: (id: string) => `${cardsBasePrefix}invoices/view/${id}`,
  statementView: (id: string) => `${cardsBasePrefix}statements/view/${id}`,
};

const contentBasePrefix = `${v1}/Content/`;
export const content = {
  feed: (top: number) => `${contentBasePrefix}feed/?top=${top}`,
  services: () => `${contentBasePrefix}services`,
  contact: () => `${contentBasePrefix}text/contact`,
  tariff: () => `${contentBasePrefix}text/tariff`,
  tariffJson: () => `${contentBasePrefix}json/tariff`,
  siteTC: () => `${contentBasePrefix}text/siteTC`,
  cardsTC: () => `${contentBasePrefix}text/cardsTC`,
  cookies: () => `${contentBasePrefix}text/cookies`,
  privacy: () => `${contentBasePrefix}text/privacy`,
};

const lettersBasePrefix = `${v1}/Letters/`;
export const letters = {
  letters: () => `${lettersBasePrefix}`,
  deleteLetters: (id?: string) => `${lettersBasePrefix}${id}`,
  lettersContent: (id: string) => `${lettersBasePrefix}content/${id}`,
  lettersDownload: (id: string) => `${lettersBasePrefix}attachements/download/${id}`,
  lettersView: (id: string) => `${lettersBasePrefix}download/${id}`,
  lettersPrint: (id: string) => `${lettersBasePrefix}print/${id}`,
  lettersArchive: (id: string) => `${lettersBasePrefix}archive/${id}`,
  lettersCount: () => `${lettersBasePrefix}unread_count`,
  lettersWithAttachments: () => `${lettersBasePrefix}withAttachments`,
};

const profileBasePrefix = `${v1}/Profile/`;
export const profile = {
  profile: () => `${profileBasePrefix}`,
  changePassword: () => `${profileBasePrefix}changePassword`,
  securityQuestions: () => `${profileBasePrefix}security-questions`,
  getc2cpaymenturl: () => `${profileBasePrefix}getc2cpaymenturl`,
  getc2cfeepercent: () => `${profileBasePrefix}getc2cfeepercent`,
};
